// src/components/InboxContent.tsx
import React from "react";
import { useNovuUI } from "../context/NovuUIContext.js";
import { useRenderer } from "../context/RendererContext.js";
import { Mounter } from "./Mounter.js";
import { withRenderer } from "./Renderer.js";
import { jsx } from "react/jsx-runtime";
var _InboxContent = React.memo((props) => {
  const {
    onNotificationClick,
    onPrimaryActionClick,
    renderNotification,
    renderAvatar,
    renderSubject,
    renderBody,
    renderDefaultActions,
    renderCustomActions,
    onSecondaryActionClick,
    initialPage,
    hideNav
  } = props;
  const { novuUI } = useNovuUI();
  const { mountElement } = useRenderer();
  const mount = React.useCallback(
    (element) => {
      if (renderNotification) {
        return novuUI.mountComponent({
          name: "InboxContent",
          element,
          props: {
            renderNotification: renderNotification ? (el, notification) => mountElement(el, renderNotification(notification)) : void 0,
            onNotificationClick,
            onPrimaryActionClick,
            onSecondaryActionClick,
            initialPage,
            hideNav
          }
        });
      }
      return novuUI.mountComponent({
        name: "InboxContent",
        element,
        props: {
          renderAvatar: renderAvatar ? (el, notification) => mountElement(el, renderAvatar(notification)) : void 0,
          renderSubject: renderSubject ? (el, notification) => mountElement(el, renderSubject(notification)) : void 0,
          renderBody: renderBody ? (el, notification) => mountElement(el, renderBody(notification)) : void 0,
          renderDefaultActions: renderDefaultActions ? (el, notification) => mountElement(el, renderDefaultActions(notification)) : void 0,
          renderCustomActions: renderCustomActions ? (el, notification) => mountElement(el, renderCustomActions(notification)) : void 0,
          onNotificationClick,
          onPrimaryActionClick,
          onSecondaryActionClick,
          initialPage,
          hideNav
        }
      });
    },
    [
      renderNotification,
      renderAvatar,
      renderSubject,
      renderBody,
      renderDefaultActions,
      renderCustomActions,
      onNotificationClick,
      onPrimaryActionClick,
      onSecondaryActionClick
    ]
  );
  return /* @__PURE__ */ jsx(Mounter, { mount });
});
var InboxContent = withRenderer(_InboxContent);
export {
  InboxContent
};
//# sourceMappingURL=InboxContent.js.map